var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToggleCategoryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 10.4677L7.76597 14.7017C7.36198 15.1057 6.70698 15.1057 6.30299 14.7017C5.899 14.2977 5.899 13.6427 6.30299 13.2387L11.2685 8.27321C11.6725 7.86922 12.3275 7.86922 12.7315 8.27321L17.697 13.2387C18.101 13.6427 18.101 14.2977 17.697 14.7017C17.293 15.1057 16.638 15.1057 16.234 14.7017L12 10.4677Z",
    fill: "#00624F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleCategoryIcon);
export default __webpack_public_path__ + "static/media/toggleCategoryIcon.4166c7c5ee357d1077f219969fad3afd.svg";
export { ForwardRef as ReactComponent };